import { render, staticRenderFns } from "./AddFileRequirement.vue?vue&type=template&id=68fc9b5e&"
import script from "./AddFileRequirement.vue?vue&type=script&lang=js&"
export * from "./AddFileRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports